import Vue from 'vue';
import store from './store';
import router from './router';
import VueResource from 'vue-resource';
import VueCordova from './utils/vue-cordova';
import { mapGetters } from 'vuex';
import App from './App';
import moment from 'moment-timezone';

Vue.config.productionTip = false;

Vue.use(VueResource);
Vue.use(VueCordova);

let isCordova = false;
// add cordova.js only if serving the app through file://
if (window.location.protocol === 'file:' || window.location.port === '3000') {
    var cordovaScript = document.createElement('script');
    cordovaScript.setAttribute('type', 'text/javascript');
    cordovaScript.setAttribute('src', 'cordova.js');
    document.body.appendChild(cordovaScript);
    isCordova = true;
}

Vue.mixin({
    computed: {
        ...mapGetters({
            translate: 'translation/translate'
        })
    }
});

if (document.getElementById('app')) {
    new Vue({
        el: '#app',
        router,
        store,
        template: '<App/>',
        components: { App },
        mounted: function () {
            if (isCordova) {
                Vue.cordova.on('deviceready',
                    () => {
                        store.dispatch('settings/init', { params: this.$route.params, query: this.$route.query, isCordova: isCordova });
                    });
            } else {
                store.dispatch('settings/init', { params: this.$route.params, query: this.$route.query, isCordova: isCordova  });
            }
        }
    });
}
export { moment };





// WEBPACK FOOTER //
// ./src/main.js